import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import { useFirestore } from "vuefire";
import {
  collection,
  doc,
  deleteDoc,
  updateDoc,
  addDoc,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyASjt-PKqRg1VtmEkyKmxWkx2mwSjA_LJ0",
  authDomain: "tinnitus-dissolves-a18eb.firebaseapp.com",
  projectId: "tinnitus-dissolves-a18eb",
  storageBucket: "tinnitus-dissolves-a18eb.appspot.com",
  messagingSenderId: "754480718123",
  appId: "1:754480718123:web:42e9ea65a18db51737e56e",
  measurementId: "G-0SX6M6MN5B"
};


export const firebaseApp = () => {
  return firebase;
};

export const firebase = initializeApp(firebaseConfig);
export const auth = getAuth();
export const db = useFirestore();

export const couponRef = collection(
  db,
  `coupon`
);

export const signIn = async function (email, password) {
  return await signInWithEmailAndPassword(auth, email, password);
};

export const logOut = async function () {
  try {
    await signOut(auth);
  } catch (e) {
    return false;
  }

  return true;
};

export const addDocument = async function (ref, payload) {
  await addDoc(ref, payload);
};

export const deleteDocument = async function (ref, documentId) {
  await deleteDoc(doc(ref, documentId));
};

export const updateDocument = async function (ref, payload) {
  await updateDoc(ref, payload);
};

export const updateDocumentById = async function (ref, documentId, payload) {
  await updateDoc(doc(ref, documentId), payload);
};
